import { useSelector } from 'react-redux'
import { canViewOtherProfiles } from '../../store/selectors/role-selectors'
import { authInfo } from '../../store/selectors/auth-selectors'

interface MenuItem {
    id: string
    label: string
    url: string
    condition?: () => boolean
}

export const useAppHeaderMenuItems = () => {
    const auth = useSelector(authInfo)
    let hasEmployeesMenuItem = !!useSelector(canViewOtherProfiles)

    const menuItems: MenuItem[] = [
        {
            id: 'Profile',
            label: 'Profile',
            url: `/profile/${auth.user?.user_id}`,
        },
        {
            id: 'Skills',
            label: 'Skills',
            url: '/skills',
        },
        {
            id: 'Employees',
            label: 'Employees',
            url: '/search',
            condition: () => hasEmployeesMenuItem,
        },
        {
            id: 'Approve-employees',
            label: 'Approve Employees',
            url: '/approve-employees',
            condition: () => !!auth.user?.skills_to_approve,
        },
    ]

    return {
        menuItems: menuItems.filter((item) => item.condition === undefined || item.condition()),
    }
}
